import { render, staticRenderFns } from "./component-img-txt.vue?vue&type=template&id=f90c98b2&"
import script from "./component-img-txt.vue?vue&type=script&lang=js&"
export * from "./component-img-txt.vue?vue&type=script&lang=js&"
import style0 from "./component-img-txt.vue?vue&type=style&index=0&id=f90c98b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports